<template>
  <div class="edit-post">
    <div class="edit-post-button" @click="editPost">
      <a class="edit-post-text">
        {{ $t('post.postEdit.edit') }}
      </a>
    </div>
    <modal
      @close="closeModal"
      class="modal"
      v-if="showModal"
      :width="'865px'"
    >
      <div slot="header" class="modal-header">
        {{ $t('post.postEdit.editPost') }}
      </div>
      <post-form
        slot="body"
        :community-list="[post.community]"
        :multiple-community-choice="false"
        :edit-mode="true"
        :initial-post="post"
        @close="closeModal"
      />
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/shared/Modal'
import { mapState } from 'vuex'
import PostForm from '@/components/post/PostForm'

export default {
  name: 'EditPost',
  components: { PostForm, Modal },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    editPost() {
      this.showModal = true
    }
  },
  computed: mapState({
    userId: state => state.user.user.id
  })
}
</script>
<style scoped>
.edit-post {
  width: 100%;
  height: 100%;
}

.edit-post-button {
  padding: 4px 12px;
  width: 100%;
  height: 100%;
}
</style>
